import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  transform(items: any[], term: string, obj: any): any {
    console.log(items, term, obj)
    console.log(items.filter(item => {
      if (item[obj] === term) {
        return item;
      }
    }));
    if ( (typeof(term) == undefined ) || term === '') {
      console.log('1');
      return items;
    }
    return items.filter(item => {
      if (item[obj] === term) {
        return item;
      }
    });
  }

}
